import * as React from 'react';
import { useMemo } from 'react';
import cn from 'classnames';
import { FareFeaturePaymentType } from '@websky/graphql';
import { useTheme } from '../../../../../theme';
import { CdnIcon, SafeHtml } from '@shared/ui';
const ICON_NAME_BY_PAYMENT_TYPE = {
    [FareFeaturePaymentType.Free]: 'Info/Item Icluded',
    [FareFeaturePaymentType.Pay]: 'Info/Item Paid',
    [FareFeaturePaymentType.NotAvailable]: 'Info/Not included'
};
const Cell = ({ cell, isFullFareCondition, customAvailabilityIcons }) => {
    const { Cell: css, Content: contentCss } = useTheme('CompareFares');
    if (!cell) {
        return (React.createElement("div", { className: cn(css.cell, {
                [css.cell_notFullFareConditions]: !isFullFareCondition
            }) },
            React.createElement("div", { className: css.cellContent }, '')));
    }
    const { description, availability } = cell;
    const icon = useMemo(() => {
        if (customAvailabilityIcons === null || customAvailabilityIcons === void 0 ? void 0 : customAvailabilityIcons[availability]) {
            return customAvailabilityIcons[availability];
        }
        return React.createElement(CdnIcon, { icon: ICON_NAME_BY_PAYMENT_TYPE[availability] });
    }, [customAvailabilityIcons, availability]);
    return (React.createElement("div", { className: cn(css.cell, {
            [css.cell_notFullFareConditions]: !isFullFareCondition
        }) },
        isFullFareCondition && (React.createElement("div", { className: contentCss.col },
            React.createElement(SafeHtml, { tag: "div", className: cn(css.cellContent, css.cellContent_fullDescr), html: description }))),
        !isFullFareCondition && (React.createElement("div", { className: css.cellContent },
            React.createElement("div", { className: cn(css.availabilityIcon, {
                    [css.availabilityIcon_paid]: availability === FareFeaturePaymentType.Pay,
                    [css.availabilityIcon_included]: availability === FareFeaturePaymentType.Free,
                    [css.availabilityIcon_notAvailable]: availability === FareFeaturePaymentType.NotAvailable
                }) }, icon)))));
};
export default Cell;
